/* eslint-disable no-unused-vars  */
/* eslint-disable no-shadow  */
/* eslint-disable func-names */
/* eslint-disable eqeqeq */

var init = {
  showFlashMessage: function (type, message) {
    $(".site-alert").remove();
    $('<div class="site-alert challenge-allert ' + type + ' container-medium" style="margin-top:0px; top: 100%; color: white; text-align: center; background-color: #50CD89">' +
        '<p>' + message + '</p>' + '</div>')
        .appendTo($("div.sticky"));

    window.setTimeout(() => {
      $(".site-alert").fadeOut(300, function () {
        $(this).remove();
      });
    }, 6000);

  }
}
jQuery(window).resize(() => {
  jQuery("body").removeClass("introAnim fullAnim");
});

function initCycle(classForCycle) {
  const cycleclients = jQuery(classForCycle);

  // if (cycleclients.length) {
  //   jQuery(classForCycle).cycle({
  //     slides: ".cycle-item",
  //     prev: ".cycle-prev",
  //     next: ".cycle-next",
  //     timeout: 0,
  //     swipe: true,
  //     pager: "> .cycle-pager",
  //   });
  // }
}
function renderCycle(classForCycle) {
  let intialized = false;
  function toggleCycle(classForCycle) {
    // if (jQuery(window).width() > 980) {
    //   if (intialized === true) {
    //     jQuery(classForCycle).cycle("destroy");
    //
    //     intialized = false;
    //   }
    // } else {
    //   // intialized = true;
    //
    //   initCycle(classForCycle);
    // }
  }

  toggleCycle(classForCycle);
  jQuery(window).resize(() => {
    toggleCycle(classForCycle);
  });
}

// clients list - slider on responsive
renderCycle(".clients-module__row .cycle-cnt");
renderCycle(".home-path-selection .cycle-cnt");
renderCycle(".whitelabel-cnt .cycle-cnt");

function scrollFunctionHeader() {
  if (document.body.scrollTop > 1 || document.documentElement.scrollTop > 1) {
    document.getElementsByTagName("header")[0].classList.add("scrolled");
  } else {
    document.getElementsByTagName("header")[0].classList.remove("scrolled");
  }
}
function scrollFunctionTop() {
  // Check if element with id "toTopBtn" exists
  if (!document.getElementById("toTopBtn")) {
    return;
  }

  if (
    document.body.scrollTop > 300 ||
    document.documentElement.scrollTop > 300
  ) {
    document.getElementById("toTopBtn").style.opacity = "1";
  } else {
    document.getElementById("toTopBtn").style.opacity = "0";
  }
}
window.onscroll = function () {
  const header = jQuery("header");

  if (header.length) {
    scrollFunctionTop();
    scrollFunctionHeader();
  }
};

function sendParseAckForSection(sectionName) {
  const badge$ = $("[data-tab=" + sectionName + "] .updated-badge");
  if (badge$.length) {
    $.ajax({
      type: "post",
      url: "/section-parse-ack",
      data: {
        section: sectionName,
      },
      dataType: "json",
      success() {
        badge$.hide();
      },
    });
  }
}

jQuery(document).ready(() => {
  // TOTOP
  jQuery(".toTopBtn").on("click", () => {
    jQuery("html, body").animate(
      {
        scrollTop: jQuery(".shell").offset().top,
      },
      500
    );
  });
  // toggle clipped content
  jQuery(".clipped-handler").on("click", function () {
    if (!jQuery(this).parent().hasClass("clipped-expanded")) {
      jQuery(".clipped-expanded").removeClass("clipped-expanded");
    }
    jQuery(this).parent().toggleClass("clipped-expanded");
  });
  // Home in page navigation:
  jQuery("a[data-link]").on("click", function () {
    const link = jQuery(this).attr("data-link");

    if (jQuery(window).width() > 768) {
      jQuery("html, body").animate(
        {
          scrollTop: jQuery("#" + link).offset().top,
        },
        500
      );
    } else {
      jQuery("html, body").animate(
        {
          scrollTop: jQuery("#" + link).offset().top - 90,
        },
        500
      );
    }
  });
  // menu expand
  jQuery(".menu-icon").on("click", function () {
    jQuery(this).closest("header").toggleClass("expanded");
    if (jQuery("body.menuOpen").length) {
      jQuery("body.menuOpen").removeClass("menuOpen");
    } else {
      jQuery("body").addClass("menuOpen");
    }
  });

  jQuery(".mobile-burger").on("click", function () {
    jQuery(this).closest("header").toggleClass("expanded");
    if (jQuery("body.menuOpen").length) {
      jQuery("body.menuOpen").removeClass("menuOpen");
    } else {
      jQuery("body").addClass("menuOpen");
    }
  });

  jQuery(document.body).mousedown((event) => {
    const target = jQuery(event.target);
    if (!target.parents().addBack().is(".expanded")) {
      // Clicked outside
      jQuery(".expanded").removeClass("expanded");
      jQuery("body").removeClass("menuOpen");
    }
  });
  // END menu expand

  // langSelector, account drop and notifications drop
  jQuery(
    ".langSelector .isSelected, nav .userAccount .actTrigger, nav .notifications .notifsTrigger, .r_simple-list__trigge, .toggleOpenParent"
  ).on("click", function () {
    jQuery(this).parent().toggleClass("open");
  });
  jQuery(".dropdownToggle").on("click", function () {
    jQuery(this).parent().toggleClass("open");
  });

  jQuery(document.body).mousedown((event) => {
    const target = jQuery(event.target);
    if (!target.parents().addBack().is(".open")) {
      // Clicked outside
      jQuery(".open").removeClass("open");
    }
  });

  // ////////////////
  jQuery(".quiz-module .next")
    .not(".prefilled")
    .on("click", () => {
      jQuery(".quiz-module fieldset.current")
        .removeClass("current")
        .next("fieldset")
        .addClass("current");
      if (jQuery(".quiz-module__questions").attr("data-active") === 1) {
        jQuery(".quiz-module__questions").attr("data-active", "2");
        jQuery(".quiz-module__nav .prev").removeClass("inactive");
        jQuery(".quiz-module__nav .active")
          .removeClass("active")
          .next()
          .addClass("active");
      } else if (jQuery(".quiz-module__questions").attr("data-active") === 2) {
        jQuery(".quiz-module__questions").attr("data-active", "3");
        jQuery(".quiz-module__nav .next").addClass("inactive");
        jQuery(".quiz-module__nav .active")
          .removeClass("active")
          .next()
          .addClass("active");
      }
    });
  jQuery(".quiz-module .prev").on("click", () => {
    jQuery(".quiz-module fieldset.current")
      .removeClass("current")
      .prev("fieldset")
      .addClass("current");
    if (jQuery(".quiz-module__questions").attr("data-active") === 2) {
      jQuery(".quiz-module__questions").attr("data-active", "1");
      jQuery(".quiz-module__nav .prev").addClass("inactive");
      jQuery(".quiz-module__nav .active")
        .removeClass("active")
        .prev()
        .addClass("active");
    } else if (jQuery(".quiz-module__questions").attr("data-active") === 3) {
      jQuery(".quiz-module__questions").attr("data-active", "2");
      jQuery(".quiz-module__nav .next").removeClass("inactive");
      jQuery(".quiz-module__nav .active")
        .removeClass("active")
        .prev()
        .addClass("active");
    }
  });
  jQuery(".r_homepage .quiz-module input[type=radio]").on(
    "change",
    function () {
      jQuery(this).parent().parent().addClass("check");
      jQuery(".quiz-module__nav.prevent").removeClass("prevent");

      if (!jQuery("fieldset.current").hasClass("last")) {
        jQuery(".quiz-module fieldset.current")
          .removeClass("current")
          .next("fieldset")
          .addClass("current");
      }
      if (jQuery(".quiz-module__questions").attr("data-active") == 1) {
        jQuery(".quiz-module__questions").attr("data-active", "2");
        jQuery(".quiz-module__nav .prev").removeClass("inactive");
        jQuery(".quiz-module__nav .active")
          .removeClass("active")
          .next()
          .addClass("active");
      } else if (jQuery(".quiz-module__questions").attr("data-active") == 2) {
        jQuery(".quiz-module__questions").attr("data-active", "3");
        jQuery(".quiz-module__nav .next").addClass("inactive");
        jQuery(".quiz-module__nav .active")
          .removeClass("active")
          .next()
          .addClass("active");
      }
      // ///////
      if (jQuery(this).parent().parent().hasClass("last")) {
        jQuery(".quiz-module").addClass("quizDone");
      }
    }
  );
  jQuery(".quiz-module .seeResult .btn").on("click", () => {
    jQuery(".quiz-module").addClass("resultIsShown");
  });

  function removeHash() {
    window.history.pushState(
      "",
      document.title,
      window.location.pathname + window.location.search
    );
  }

  function scrollTopOrToBeacon() {
    const scrollBeacon = $("#scrollBeacon");
    if (scrollBeacon.length) {
      $("html, body").animate(
        {
          scrollTop: scrollBeacon.offset().top,
        },
        300
      );
    } else {
      jQuery(window).scrollTop(0);
    }
  }

  // Resume tabs
  jQuery(".resumeTabs li[data-tab]").on("click", function () {
    jQuery(".resumeTabs li.current").removeClass("current");

    const tabId = jQuery(this).data("tab");
    jQuery(this).addClass("current");

    jQuery(".class-hash").val(tabId);

    jQuery("section .tab.current").removeClass("current");
    jQuery("#" + tabId).addClass("current");

    if (jQuery(".resumeTabs.expanded").length) {
      jQuery(".resumeTabs").removeClass("expanded");
    }

    // add to url=
    removeHash();
    const url = document.location.href + "#" + tabId;
    document.location = url;

    scrollTopOrToBeacon();

    sendParseAckForSection(tabId);
  });

  // activate tab if it was previously selected
  if (window.location.hash) {
    const hashI = window.location.hash.substring(1);
    jQuery(".class-hash").val(hashI);

    const elements = jQuery('.resumeTabs li[data-tab="' + hashI + '"]');
    if (elements.length === 0) {
      jQuery(".resumeTabs li:first").addClass("current"); // Activate first tab
      jQuery(".r_resume-edit .tab:first").addClass("current"); // Show first tab content
    } else {
      jQuery(window).scrollTop(0);
      // elements.click();
      jQuery(".resumeTabs li.current, section .tab.current").removeClass(
        "current"
      );
      jQuery("#" + hashI).addClass("current");
      jQuery('.resumeTabs li[data-tab="' + hashI + '"]').addClass("current");

      sendParseAckForSection(hashI);
    }
  }

  // Resume tabs on mobile
  jQuery(".resumeTabs .toggleArr").on("click", () => {
    if (jQuery(".resumeTabs.expanded").length) {
      jQuery(".resumeTabs").removeClass("expanded");
    } else {
      jQuery(".resumeTabs").addClass("expanded");
    }
  });

  // switch to edit mode on resume page
  jQuery(".editIco:not(.static)").on("click", function () {
    jQuery(this).closest(".r_card").addClass("editmode");
  });

  // / circular progress
  // jQuery(".testedSkillSection input.progress").knob({
  //   min: 0,
  //   max: 100,
  //   readOnly: true,
  //   thickness: 0.1,
  //   width: 75,
  //   height: 75,
  //   fgColor: "#F05C63",
  //   fontWeight: "700",
  // });

  // refferals slider
  // jQuery(".refferralsSlider .sliderHolder").cycle({
  //   slides: ".slide",
  //   prev: ".cycle-prev",
  //   next: ".cycle-next",
  //   timeout: 10000,
  //   swipe: true,
  //   autoHeight: "container",
  // });

  // generic slider
  // jQuery(".genericSlider .sliderHolder").cycle({
  //   slides: ">.slide",
  //   prev: ".cycle-prev",
  //   next: ".cycle-next",
  //   timeout: 0,
  //   swipe: true,
  //   autoHeight: "container",
  // });

  // ///////////
  jQuery(".dropHandler").on("click", function () {
    jQuery(this)
      .closest(".skillsSectionRow__resultElem")
      .toggleClass("expanded");
  });

  jQuery(".userNotes, .inviteIco, .inviteLink").on("click", function () {
    jQuery(this).next(".userPop").addClass("open");
  });

  jQuery(".userPop .noteFoot .discard").on("click", () => {
    jQuery(".userPop").removeClass("open");
  });

  // .resumeSectionTitle
  jQuery(document).on("click", ".resumeSectionTitle .toggleArr", function () {
    jQuery(this).closest(".r_card").toggleClass("extended");
  });

  // close panel if clicked outside
  jQuery(document.body).mousedown((event) => {
    const target = jQuery(event.target);
    if (!target.parents().addBack().is(".extended")) {
      // Clicked outside
      jQuery(".extended").not(".itExtends").removeClass("extended");
    }
  });

  // profile page
  // / circular avatar level progress
  // jQuery(".levelProgress input.progress").knob({
  //   min: 0,
  //   max: 100,
  //   readOnly: true,
  //   thickness: 0.2,
  //   width: 150,
  //   height: 150,
  //   fgColor: "#F05C63",
  //   bgColor: "#F5F5F5",
  //   fontWeight: "700",
  // });

  // newsSlider slider
  // jQuery(".newsSlider").cycle({
  //   slides: ">.slide",
  //   prev: ".prevNews",
  //   next: ".nextNews",
  //   timeout: 0,
  //   swipe: true,
  //   autoHeight: false,
  //   caption: ".newsCount",
  //   captionTemplate: "{{slideNum}}/{{slideCount}}",
  // });
  // dismiss news
  // jQuery('.r_card__news .dismiss').on('click', () => {
  //     jQuery('.newsList, .newsSlider').remove();
  //     jQuery('.r_card__news').removeClass('extended').addClass('isEmpty');
  // });

  // / circular progress
  // jQuery(".r_card__diplomas input.progress").knob({
  //   min: 0,
  //   max: 100,
  //   readOnly: true,
  //   thickness: 0.1,
  //   width: 65,
  //   height: 65,
  //   fgColor: "#F05C63",
  //   fontWeight: "700",
  // });

  // toggle questions

  jQuery(".r_question-item .toggleArr").on("click", function () {
    jQuery(this).closest(".r_question-item").toggleClass("extended");
  });

  // graduates filter
  jQuery(".filterHandler").on("click", function () {
    jQuery(this).toggleClass("active");
    jQuery(this)
      .closest(".tabular-data")
      .find(".filterHolder")
      .toggleClass("active");
  });

  // graduates extra details
  jQuery(".r_graduates-page .toggleArr").on("click", function () {
    jQuery(this).closest(".tabular-data__row").toggleClass("activeRow");
  });

  // pricing form
  jQuery(
    ".r_pricing__item .formTrigger, .r_subscriptions__item .formTrigger, .plans-choice .formTrigger"
  ).on("click", function () {
    jQuery(this).parent().toggleClass("expanded");
  });
  jQuery(".recruiter-plans .formTrigger").on("click", function () {
    jQuery(this).parent().parent().toggleClass("expanded");
  });
});

// //////////////////////////////////////////////////////////////
// Resume tabs on mobile
function asideCollapse() {
  const currentResumeTabHeight = jQuery(".resumeTabs li.current").outerHeight();
  jQuery(".resumeTabs, .resumeTabs ul").css(
    "padding-top",
    currentResumeTabHeight
  );
  jQuery(".resumeTabs ul").css("max-height", currentResumeTabHeight);
}
function asideReCollapse() {
  jQuery(".resumeTabs, .resumeTabs ul").css("padding-top", "");
  jQuery(".resumeTabs ul").css("max-height", "");
}
if (jQuery(".resumeTabs").length) {
  if (jQuery(window).width() < 767) {
    asideCollapse();
  }
  jQuery(window).resize(() => {
    if (jQuery(window).width() < 767) {
      asideCollapse();
    } else {
      asideReCollapse();
    }
  });
}

// end aside menu tabs on mobile

// position badge description
jQuery(() => {
  // whenever we hover over a menu item that has a submenu
  const userBadgesContainer = document.querySelector(
    ".r_card_badges .userBadges"
  );

  jQuery(".r_card_badges .userBadges li").on("mouseover", function () {
    const $menuItem = $(this);
    const $submenuWrapper = jQuery(".userBadges__description", $menuItem);

    // grab the menu item's position relative to its positioned parent
    const menuItemPos = $menuItem.position();
    let field = "right";
    let pos = 0;

    if (userBadgesContainer.classList.contains("userBadgesLeft")) {
      field = "left";
      pos = jQuery(this).position().left - 20;
    } else {
      pos =
        jQuery(".r_card_badges").width() -
        jQuery(this).position().left -
        jQuery(this).width() -
        13;
    }

    // place the submenu in the correct position relevant to the menu item
    $submenuWrapper.css("top", menuItemPos.top + 80);
    $submenuWrapper.css(field, pos);
  });
});

// / position item details in simple lists
jQuery(() => {
  // whenever we hover over a menu item that has a submenu
  jQuery(".r_simple-list__details").on("mouseover", function () {
    const $menuItem = jQuery(this);
    const $submenuWrapper = jQuery(".r_simple-list__drop", $menuItem);
    const menuItemPos = $menuItem.position();

    $submenuWrapper.css({
      top: menuItemPos.top,
      // right: rightPos
    });
  });
});

// /////////////// friends
// split friends list
const divs = jQuery(
  ".r_friends-list .friendsSliderHolder .r_simple-list__item"
);
for (let i = 0; i < divs.length; i += 6) {
  divs.slice(i, i + 6).wrapAll("<div class='newSlide'></div>");
}

// profile friends list search:
function filter(element) {
  let value = jQuery(element).val();

  value = value
    .toLowerCase()
    .replace(/\b[a-z]/g, (letter) => letter.toUpperCase());

  jQuery("#theList .r_simple-list__item:contains(" + value + ")").addClass(
    "resulted"
  );
  jQuery(
    "#theList .r_simple-list__item:not(:contains(" + value + "))"
  ).removeClass("resulted");

  jQuery(".r_friends-list").addClass("searchingFriends");
}

// jQuery(document).ready(() => {
//   // newsSlider slider
//   jQuery(".r_friends-list .friendsSliderHolder").cycle({
//     slides: ".newSlide",
//     prev: ".prevFriends",
//     next: ".nextFriends",
//     timeout: 0,
//     swipe: true,
//     autoHeight: false,
//     caption: ".friendsListsCount .r_pagination__indicator",
//     captionTemplate: "page {{slideNum}} of {{slideCount}}",
//   });
//
//   jQuery("#searchFriendsInput").blur(function () {
//     jQuery(".r_friends-list").removeClass("searchingFriends");
//     jQuery("#theList .r_simple-list__item").removeClass("resulted");
//     jQuery(this).val("");
//   });
// });

// allowing the user to add a maximum of 3 domains, in the availability section.
if (jQuery(".availabilitySection").length) {
  let countDomains = 0;

  jQuery(".availabilitySection")
    .find("select[name='domains[]']")
    .each(() => {
      countDomains += 1;
    });

  if (countDomains > 2) {
    jQuery("#add-availability").addClass("hidden");
  }
}

// r_resume-edit
jQuery(document).ready(() => {
  jQuery("#aboutForm").validate();
  jQuery("#availabilityForm").validate();
  jQuery("#experienceForm").validate();
  jQuery("#skillsForm").validate();
  jQuery("#languagesForm").validate();
  jQuery("#bookDmo").validate();

  jQuery("#cvMainForm").validate();

  jQuery.validator.addClassRules("requiredField", {
    required: true,
  });

  if (jQuery("#cvMainForm").length) {
    jQuery(document.body).mousedown(() => {
      jQuery(".resumeTabs li").removeClass("tabError");

      if (jQuery("label.error").length) {
        jQuery('label.error:not([style*="none"])').each(function () {
          const errLocation = jQuery(this).closest(".tab").attr("id");

          jQuery('.resumeTabs li[data-tab="' + errLocation + '"]').addClass(
            "tabError"
          );
        });
      }
    });
  }

  jQuery("#addChallengeForm").validate();
  jQuery("#addPipelineForm").validate();
  jQuery("#addContactForm").validate();
  jQuery("#editCompanyProfile").validate();
  jQuery("#editJob").validate();

  jQuery("#starSeeker").validate();
  jQuery("#serialHunter").validate();
  jQuery("#hiringMaster").validate();
  jQuery("#subscribe-academy").validate();
  jQuery("#subscribe-challanges").validate();
  jQuery("#r_login_form").validate();
  jQuery("#r_register_form").validate();
  jQuery("#r_login_company_form").validate();
  jQuery("#r_forgot-password_form").validate();
  jQuery("#r_register-as-company_form").validate();

  jQuery("#referForm").validate();

  jQuery("#search-friend").validate();
  jQuery("#search-friends-list").validate();
  jQuery("#search-ref-list").validate();

  jQuery("#onboardingReg").validate();
  jQuery("#search-card").validate();

  jQuery("#business-report").validate();

  jQuery("#employer-plan").validate();
  jQuery("#recruiter-plan").validate();
  jQuery("#talent-plan").validate();

  // popups

  jQuery(".js-popup-trigger").on("click", function () {
    jQuery(".r_popup").removeClass("active");

    const cnt = jQuery(this).attr("data-modal");
    jQuery("#" + cnt).addClass("active");

    // add to url=
    const newCnt = cnt.replace("js-", "");

    const url = document.location.href + "#" + newCnt;
    document.location = url;
  });

  function removeHash() {
    window.history.pushState(
      "",
      document.title,
      window.location.pathname + window.location.search
    );
  }

  jQuery(
    ".r_popup:not(.persistent) .r_overlay, .r_popup__close, .r_popup .close"
  ).on("click", () => {
    removeHash();

    jQuery(".r_popup.active").removeClass("active");
  });

  // //////
  jQuery(".r_popup .js-switch-to-register").on("click", () => {
    removeHash();
    jQuery(".r_popup.active").removeClass("active");
    jQuery("#js-register").addClass("active");

    const url = document.location.href + "#register";
    document.location = url;
  });

  jQuery(".js-open-register").on("click", () => {
    removeHash();
    jQuery(".r_popup.active").removeClass("active");
    jQuery("#js-register").addClass("active");

    const url = document.location.href + "#register";
    document.location = url;
  });

  jQuery(".js-switch-to-company-register").on("click", () => {
    removeHash();
    jQuery(".r_popup.active").removeClass("active");
    jQuery("#js-company-register").addClass("active");

    const url = document.location.href + "#company-register";
    document.location = url;
  });

  jQuery(".r_popup .js-switch-to-login").on("click", () => {
    removeHash();
    jQuery(".r_popup.active").removeClass("active");
    jQuery("#js-login").addClass("active");

    const url = document.location.href + "#login";
    document.location = url;
  });
  jQuery(".r_popup .js-switch-to-company-login").on("click", () => {
    removeHash();
    jQuery(".r_popup.active").removeClass("active");
    jQuery("#js-company-login").addClass("active");

    const url = document.location.href + "#login";
    document.location = url;
  });

  jQuery(".r_popup .js-switch-to-forgot").on("click", () => {
    removeHash();
    jQuery(".r_popup.active").removeClass("active");
    jQuery("#js-forgot-password").addClass("active");

    const url = document.location.href + "#forgot-password";
    document.location = url;
  });

  jQuery(".r_popup .js-switch-to-forgot-company").on("click", () => {
    removeHash();
    jQuery(".r_popup.active").removeClass("active");
    jQuery("#js-forgot-password-company").addClass("active");

    const url = document.location.href + "#forgot-password-company";
    document.location = url;
  });

  // activate popups if it was previously selected
  if (window.location.hash) {
    const hashPop = window.location.hash.substring(1);
    jQuery("#js-" + hashPop).addClass("active");
  }

  // jQuery(".tabular-data .sortable").on("click", function () {
  //   jQuery(this).toggleClass("reverse");
  // });
  // jQuery("select")
  //   .not(
  //     ".ql-snow select, .salary_options, .skill-category-input, .skill-input, .job-title-select, .skill-select, .no-select2"
  //   )
  //   .select2({});

  jQuery(".avatar-switch").on("click", function () {
    jQuery(this).toggleClass("open");
  });

  // / autogrow textarea
  // $(() => {
  //   $("textarea").on("keyup paste", function () {
  //     const $el = $(this);
  //     const offset = $el.innerHeight() - $el.height();

  //     if ($el.innerHeight() < this.scrollHeight) {
  //       // Grow the field if scroll height is smaller
  //       $el.height(this.scrollHeight - offset);
  //     } else {
  //       // Shrink the field and then re-set it to the
  //       // scroll height in case it needs to shrink
  //       $el.height(1);
  //       $el.height(this.scrollHeight - offset);
  //     }
  //   });
  // });

  jQuery(".matching-lists h4").on("click", function () {
    jQuery(this).toggleClass("expand");
  });

  // Tabs
  function selectTab(tabId) {
    jQuery(".tabbedcnt li.current").removeClass("current");
    jQuery(".tabbedcnt [data-tab=" + tabId + "]").addClass("current");
    jQuery(".tab__cnt.current").removeClass("current");
    jQuery("#" + tabId).addClass("current");
  }

  function onHashChange() {
    const tabIdHash = window.location.hash;
    if (tabIdHash && tabIdHash.length > 0) {
      const tabId = tabIdHash.substring(1);
      selectTab(tabId);
      jQuery(".tabbedcnt [data-tab=" + tabId + "]").addClass("current");
    }
  }

  jQuery(".tabbedcnt li[data-tab]").on("click", function () {
    const tabId = jQuery(this).data("tab");
    selectTab(tabId);
    jQuery(this).addClass("current");
    if (window.history.pushState) {
      window.history.pushState(null, null, "#" + tabId);
    } else {
      window.location.hash = "#" + tabId;
    }
  });

  window.addEventListener("hashchange", onHashChange, false);
  onHashChange();

  // Toggle job categories in sidebar
  jQuery(".r_jobs__category-title").on("click", function () {
    jQuery(this).closest("li").toggleClass("extended");
  });

  // generic sidebar toggle
  jQuery(".js-filter-list .toggleArr, .js-filter-list ._filter-list__title").on(
    "click",
    function () {
      jQuery(this).closest("li").toggleClass("extended");
    }
  );

  // course

  if (jQuery(window).width() < 767) {
    $("aside .r_card-title").removeClass("clipped-expanded");
  }
  jQuery(window).resize(() => {
    if (jQuery(window).width() < 767) {
      $("aside .r_card-title").removeClass("clipped-expanded");
    }
  });

  // company nurture filterHandler
  jQuery(".filterHolder .js-clearSelections").on("click", () => {
    jQuery(".filterHolder select").val("0").trigger("change");

    const added = jQuery(this)
      .closest(".tabular-data")
      .find(".filterHolder .added-filter, .filterHolder .added-filter + span");
    jQuery(added).remove();
  });

  jQuery(".js-expandDetails").on("click", function () {
    jQuery(".activeRow")
      .not(jQuery(this).closest(".tabular-data__row"))
      .removeClass("activeRow");
    jQuery(this).closest(".tabular-data__row").toggleClass("activeRow");
  });

  // Gamification sidebar
  // main tabs
  jQuery(".candidate-gamification__header--item").on("click", function () {
    const tabId = jQuery(this).data("tab");

    jQuery(
      ".candidate-gamification__header--item.current, .candidate-gamification__tab.current"
    ).removeClass("current");
    jQuery("#" + tabId).addClass("current");
    jQuery(this).addClass("current");

    const gamificationPanel = $(".candidate-gamification");

    if (!$(gamificationPanel).hasClass("expanded")) {
      $(gamificationPanel).addClass("expanded");
    }
  });

  jQuery(document.body).mousedown((event) => {
    const target = jQuery(event.target);
    if (!target.parents().addBack().is(".candidate-gamification.expanded")) {
      // Clicked outside
      jQuery(
        ".candidate-gamification__header--item.current, .candidate-gamification__tab.current"
      ).removeClass("current");
    }
  });

  // subtabs
  jQuery(".candidate-gamification__subtab-link").on("click", function () {
    const subTabId = jQuery(this).data("subtab");

    jQuery(this).siblings().removeClass("selected");
    jQuery(this)
      .closest(".candidate-gamification__tab ")
      .find(".candidate-gamification__subtab.selected")
      .removeClass("selected");

    jQuery("#" + subTabId).addClass("selected");
    jQuery(this).addClass("selected");
  });

  // Megamenu tabs

  jQuery(".mega-menu__main-list li[data-tab]").on("click", function () {
    const tabId = jQuery(this).data("tab");

    jQuery(
      ".mega-menu__main-list li.current, .mega-menu__tab.current"
    ).removeClass("current");
    jQuery("#" + tabId).addClass("current");
    jQuery(this).addClass("current");
  });
});

function getQueryParams() {
  const vars = {};
  let hash;
  let hashes = [];

  if (window.location.href.indexOf("?") > 0) {
    hashes = window.location.href
      .slice(window.location.href.indexOf("?") + 1)
      .split("&");
  }

  for (let i = 0; i < hashes.length; i += 1) {
    hash = hashes[i].split("=");
    vars[hash[0]] = hash[1];
  }

  return vars;
}

function createNewEntity(params) {
  const term = $.trim(params.term);
  return {
    id: term,
    text: term,
    newTag: true,
  };
}


function siteAlert(type, data, duration = 3000) {
  $("body").append(
    '<div class="site-alert fixed site-alert--' +
      type +
      ' site-alert--home">' +
      data +
      "</div>"
  );

  setTimeout(() => {
    $(".site-alert").remove();
  }, duration);
}

function getTextFromSelect2Elements(selector) {
  return $(selector)
    .map(function () {
      return $(this).select2("data");
    })
    .toArray()
    .map((data) => data.text);
}

function doInitOnSkillSuggestionClick(callback) {
  return function (e) {
    e.preventDefault();
    $(this).prop("disabled", true);
    const newSkillId = $(this).data("id");
    callback(newSkillId);
  };
}

function initOnSkillSuggestionClick(callback) {
  const f = doInitOnSkillSuggestionClick(callback);
  $(".suggestion").off("click", f).on("click", f);
}

function displaySkillSuggestions(
  suggestions,
  buildSuggestionHtmlElement,
  onSkillSuggestionClickCallback
) {
  const suggestionsLabel = $("#suggestions-label");
  const suggestionsContainer = $("#suggestions");
  suggestionsContainer.empty();
  suggestions.forEach((suggestion) => {
    const skillName = suggestion.entity;
    const htmlElement = buildSuggestionHtmlElement(skillName);
    if (htmlElement) {
      suggestionsContainer.append(htmlElement);
    }
  });
  if (suggestions.length > 0) {
    suggestionsLabel.show();
  } else {
    suggestionsLabel.hide();
  }
  initOnSkillSuggestionClick(onSkillSuggestionClickCallback);
}

function fetchSkillSuggestions(
  url,
  jobTitlesSelector,
  skillsSelector,
  buildSuggestionHtmlElement,
  onSkillSuggestionClickCallback
) {
  const jobTitles = getTextFromSelect2Elements(jobTitlesSelector);
  const skills = getTextFromSelect2Elements(skillsSelector);

  $.ajax({
    type: "post",
    url: url,
    data: {
      skills: skills,
      job_titles: jobTitles,
    },
    dataType: "json",
    success(suggestions) {
      displaySkillSuggestions(
        suggestions,
        buildSuggestionHtmlElement,
        onSkillSuggestionClickCallback
      );
    },
  });
}

// Messages
const showSuccessMessage = function (message) {
  // If there is another alert message being shown, remove it
  $(".site-alert").remove();
  $(
    '<div class="site-alert site-alert--home site-alert--positive container-medium" style="position: fixed; margin-top: 150px;"> <p>' +
      message +
      "</p> </div>"
  ).insertAfter($("header"));
  window.setTimeout(() => {
    $(".site-alert").fadeOut(300, function () {
      $(this).remove();
    });
  }, 3000);
};

const showErrorMessage = function (message) {
  // If there is another alert message being shown, remove it
  $(".site-alert").remove();
  $(
    '<div class="site-alert site-alert--home site-alert--negative container-medium" style="position: fixed; margin-top: 150px;"> <p>' +
      message +
      "</p> </div>"
  ).insertAfter($("header"));
  window.setTimeout(() => {
    $(".site-alert").fadeOut(300, function () {
      $(this).remove();
    });
  }, 3000);
};

/**
 * Listen for main form submit event, block it for at least 500mls, display message
 * If request lasts >500mls, the message will stay on until the request is processed
 */
// document.addEventListener("submit", function (e) {
//   const submitForm = e.target;
//   if (submitForm.matches("#cvMainForm")) {
//     e.preventDefault();
//     let buttons = document.querySelectorAll(".btn.cv-edit__save");
//     buttons.forEach(function (element, value) {
//       let loaderMessage = element.parentElement.querySelector(".loaderMessage");
//       console.log(loaderMessage);
//       loaderMessage.classList.add("displayMessage");
//     });
//     setTimeout(function () {
//       submitForm.submit();
//     }, 500);
//   }
// });

async function generalFetchRequest(endpoint, method, data) {
  try {
    const fetchResponse = await fetch(endpoint, {
      method: method,
      headers: {
        "X-CSRF-TOKEN": document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute("content"),
        "Content-Type": "application/json",
      },
      body: method === "POST" ? JSON.stringify(data) : undefined,
    });
    return fetchResponse;
  } catch (error) {
    alert(error);
  }
}

function truncateString(string, num) {
  if (string.length <= num) {
    return string;
  }
  return string.slice(0, num) + "...";
}
